<template>
  <div class="hist-page">
    <div class="hist-inner">
      <section class="hist-card hist-card--header" aria-label="Transactions">
        <h1 class="hist-title">
          {{
            $store.state.language === 'en'
              ? 'Transactions'
              : 'ငွေစာရင်းများ'
          }}
        </h1>
        <div class="hist-segments" role="tablist">
          <button
            type="button"
            role="tab"
            class="hist-seg"
            :class="{ 'hist-seg--active': transactionType === 'all' }"
            @click="fetchHistory('all')"
          >
            {{
              $store.state.language === 'en'
                ? 'Game logs'
                : 'ကစား မှတ်တမ်း'
            }}
          </button>
          <button
            type="button"
            role="tab"
            class="hist-seg"
            :class="{ 'hist-seg--active': transactionType === 'deposits' }"
            @click="fetchTransactions('deposits')"
          >
            {{
              $store.state.language === 'en'
                ? 'Deposits'
                : 'ငွေသွင်း မှတ်တမ်း'
            }}
          </button>
          <button
            type="button"
            role="tab"
            class="hist-seg"
            :class="{ 'hist-seg--active': transactionType === 'withdraws' }"
            @click="fetchTransactions('withdraws')"
          >
            {{
              $store.state.language === 'en'
                ? 'Withdrawals'
                : 'ငွေထုတ် မှတ်တမ်း'
            }}
          </button>
        </div>
        <div class="hist-filters">
          <div class="hist-select-wrap">
            <v-select
              v-model="params.date"
              :reduce="(draw) => draw.data"
              label="label"
              :options="dateOptions"
              class="hist-select"
            />
          </div>
          <button
            type="button"
            class="hist-search"
            @click="runFetch"
          >
            {{
              $store.state.language === 'en'
                ? 'Search'
                : 'ရှာမည်'
            }}
          </button>
        </div>
      </section>

      <section class="hist-card hist-card--table" aria-label="Results">
        <header class="hist-table-card-head">
          <span class="hist-table-card-head__label">{{
            $store.state.language === 'en'
              ? 'Activity list'
              : 'မှတ်တမ်း စာရင်း'
          }}</span>
        </header>
        <div class="hist-table-wrap">
          <div v-if="isLoading" class="hist-loading">
            <Loading
              color="#5c98ff"
              size="28"
              class="hist-loading__spin"
            />
            <span class="hist-loading__text">{{
              $store.state.language === 'en'
                ? 'Loading…'
                : 'ခဏစောင့်ပါ…'
            }}</span>
          </div>
          <DataTable
            v-else
            :tableData="tableData"
            @getSlipData="fetchSlipData"
          />
        </div>
        <footer class="hist-table-footer">
          <div
            v-if="!isLoading"
            class="hist-table-meta"
            aria-live="polite"
          >
            <p class="hist-table-meta__count">
              {{
                $store.state.language === 'en'
                  ? `${Number(rows).toLocaleString()} entries`
                  : `မှတ်တမ်း ${Number(rows).toLocaleString()} ခု`
              }}
            </p>
            <p class="hist-table-meta__page">
              {{
                $store.state.language === 'en'
                  ? `Page ${currentPage} of ${totalPages}`
                  : `စာမျက်နှာ ${currentPage} / ${totalPages}`
              }}
            </p>
          </div>
          <div class="hist-pagination-wrap">
            <van-pagination
              v-model="currentPage"
              :total-items="rows"
              :items-per-page="pageSize"
              :show-page-size="5"
              force-ellipses
              class="hist-pagination"
            >
              <template #prev-text>
                <span class="hist-pagination__nav">
                  <van-icon name="arrow-left" />
                  <span class="hist-pagination__nav-text">{{
                    $store.state.language === 'en' ? 'Prev' : 'ယခင်'
                  }}</span>
                </span>
              </template>
              <template #next-text>
                <span class="hist-pagination__nav">
                  <span class="hist-pagination__nav-text">{{
                    $store.state.language === 'en' ? 'Next' : 'နောက်'
                  }}</span>
                  <van-icon name="arrow" />
                </span>
              </template>
              <template #page="{ text }">{{ text }}</template>
            </van-pagination>
          </div>
        </footer>
      </section>
    </div>

    <div class="col-4">
      <div
        id="voucher-history"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered"
          role="document"
        >
          <div class="modal-content hist-modal-content">
            <div
              class="hist-modal-close"
              @click="closeModal"
            >
              ×
            </div>
            <div class="modal-body p-0">
              <FBVoucher
                :type="type"
                :datas="datas"
                :slipId="slipId"
                :currentTime="bet_date"
                :isHistory="true"
                :is_result="is_result"
                :bingo_amount="bingo_amount"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DateTime } from 'luxon';
import { Loading } from 'vant';
import DataTable from './components/DataTable.vue';
import FBVoucher from './components/FBVoucher.vue';
import { mapActions } from 'vuex';

export default {
  components: { DataTable, FBVoucher, Loading },
  data() {
    return {
      tableData: {
        headings:
          this.$store.state.language === 'en'
            ? ['Amount', 'Balance', 'Type', 'Status', 'Action By', 'Date']
            : ['ငွေအမောင့်', 'လက်ကျန်ငွေ', 'အမျိုးအစား', 'အခြေအနေ', 'လုက်ဆောင်သူ', 'နေ့စွဲ'],
        datas: [],
      },
      rows: 0,
      currentPage: 1,
      pageSize: 50,
      depositActive: false,
      withdrawActive: false,
      transactionType: 'all',
      params: {
        draw: '',
        date: '',
      },
      dateOptions: [],
      type: 'maung',
      datas: [],
      slipId: null,
      bet_date: null,
      bingo_amount: null,
      is_result: false,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    runFetch() {
      if (this.transactionType === 'all') {
        this.fetchHistory('all');
      } else {
        this.fetchTransactions(this.transactionType);
      }
    },
    setOneMonth() {
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() - i);
        const newObject = {};
        newObject.label = moment(d).format('l');
        newObject.data = d;
        this.dateOptions.push(newObject);
      }
    },
    closeModal() {
      $('#voucher-history').modal('hide');
    },
    fetchSlipData(data) {
      this.type = data.type;
      this.datas = data.team_vouchers;
      this.bingo_amount = data.bingo_amount;
      this.slipId = data.voucher_id;
      this.is_result = data.isBet;
      this.bet_date = this.betTime(data.created_at);
      $('#voucher-history').modal('show');
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString('en-US', { timeZone: targetTimeZone });
      return moment(adjustedDrawDate).format('lll');
    },
    async fetchHistory(type = 'all') {
      try {
        this.transactionType = type;
        this.isLoading = true;
        this.tableData.headings = this.$store.state.language === 'en'
          ? ['Amount', 'Balance', 'Type', 'Status', 'Action By', 'Date']
          : ['ငွေအမောင့်', 'လက်ကျန်ငွေ', 'အမျိုးအစား', 'အခြေအနေ', 'လုက်ဆောင်သူ', 'နေ့စွဲ'];
        this.tableData.contents = [
          'amount',
          'current_amount',
          'type',
          'status',
          'by_user_name',
          'created_at',
        ];
        const res = await axios.post('/transactions/get_by_solo', {
          page: this.currentPage,
          limit: this.pageSize,
          user_id: this.$store.state.authUser.id,
          drawDate: this.params.date,
          type,
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.tableData.datas = res.data.data;
        for (let index = 0; index < this.tableData.datas.length; index += 1) {
          this.tableData.datas[index].created_at = this.betTime(this.tableData.datas[index].created_at);
          this.tableData.datas[index].amount = Number(this.tableData.datas[index].amount).toLocaleString();
          this.tableData.datas[index].current_amount = Number(this.tableData.datas[index].current_amount).toLocaleString();
        }
        this.isLoading = false;
        this.rows = res.data.total;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async fetchTransactions(type) {
      try {
        this.transactionType = type;
        this.isLoading = true;
        this.tableData.headings = this.$store.state.language === 'en'
          ? ['Date', 'Amount', 'Status', 'Account', 'Remark']
          : ['နေ့စွဲ', 'ငွေအမောင့်', 'အခြေအနေ', 'အကောင့်', 'မှတ်ချက်'];
        this.tableData.contents = [
          'date',
          'amount',
          'status',
          'account',
          'remark',
        ];
        const res = await axios.get(`/${type}?page=${this.currentPage}&&limit=${this.pageSize}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.tableData.datas = res.data.data;
        for (let index = 0; index < this.tableData.datas.length; index += 1) {
          this.tableData.datas[index].amount = Number(this.tableData.datas[index].amount).toLocaleString();
        }
        this.isLoading = false;
        this.rows = res.data.total;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },
  computed: {
    totalPages() {
      if (!this.rows || this.rows < 1) return 1;
      return Math.ceil(this.rows / this.pageSize);
    },
  },
  watch: {
    currentPage() {
      this.runFetch();
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
    this.params.date = moment(new Date()).format('l');
    this.fetchHistory();
    this.setOneMonth();
  },
};
</script>
<style scoped>
.hist-page {
  min-height: 100vh;
  padding: 1rem 0.65rem 1.25rem;
  padding-bottom: calc(1.25rem + env(safe-area-inset-bottom, 0px));
  background-color: #0d0e12;
  background-image: linear-gradient(180deg, rgba(13, 14, 18, 0.92) 0%, rgba(13, 14, 18, 0.88) 100%),
    url('https://storage.googleapis.com/spacetech2/mdl/bg.png');
  background-size: cover;
  background-position: center top;
  background-attachment: scroll;
  -webkit-overflow-scrolling: touch;
}

.hist-inner {
  margin: 0 auto;
  max-width: 52rem;
}

.hist-card {
  background: #1d1f26;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  margin-bottom: 0.85rem;
  overflow: hidden;
}

.hist-card--header {
  padding-bottom: 0.85rem;
}

.hist-card--table {
  border: 1px solid rgba(92, 152, 255, 0.14);
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
  overflow: hidden;
}

.hist-table-card-head {
  align-items: center;
  background: linear-gradient(180deg, rgba(37, 40, 48, 0.95) 0%, rgba(29, 31, 38, 0.6) 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  display: flex;
  justify-content: space-between;
  padding: 0.65rem 1rem;
}

.hist-table-card-head__label {
  color: #c5cad6;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.hist-title {
  color: #e8eaef;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin: 0;
  padding: 0.85rem 1rem 0.5rem;
  text-transform: uppercase;
}

.hist-segments {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  padding: 0 0.85rem 0.85rem;
}

.hist-seg {
  -webkit-tap-highlight-color: transparent;
  background: #252830;
  border: 1px solid transparent;
  border-radius: 999px;
  color: #b4bcc8;
  cursor: pointer;
  flex: 1 1 auto;
  font-size: 0.7rem;
  font-weight: 600;
  min-width: 5.5rem;
  padding: 0.5rem 0.65rem;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.hist-seg--active {
  background: rgba(92, 152, 255, 0.22);
  border-color: rgba(92, 152, 255, 0.5);
  color: #e8f0ff;
}

.hist-filters {
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0 0.85rem 0.35rem;
}

.hist-select-wrap {
  flex: 1 1 10rem;
  min-width: 0;
}

.hist-search {
  -webkit-tap-highlight-color: transparent;
  background: linear-gradient(180deg, #6a9fff 0%, #5c98ff 100%);
  border: none;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  transition: filter 0.15s ease;
}

.hist-search:active {
  filter: brightness(1.06);
}

.hist-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 0.35rem;
}

@media (min-width: 480px) {
  .hist-table-wrap {
    padding: 0 0.65rem;
  }
}

.hist-loading {
  align-items: center;
  color: #8b95a8;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  justify-content: center;
  min-height: 10rem;
  padding: 2rem 1rem;
}

.hist-loading__spin {
  padding: 0 !important;
}

.hist-loading__text {
  font-size: 0.875rem;
}

.hist-table-footer {
  background: linear-gradient(180deg, rgba(24, 26, 32, 0.4) 0%, rgba(20, 22, 28, 0.85) 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 0 0.5rem 0.85rem;
}

@media (min-width: 480px) {
  .hist-table-footer {
    padding: 0 0.85rem 1rem;
  }
}

.hist-table-meta {
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 1rem;
  justify-content: space-between;
  padding: 0.75rem 0.25rem 0.6rem;
}

.hist-table-meta__count {
  color: #e8eaef;
  font-size: 0.8125rem;
  font-weight: 600;
  margin: 0;
}

.hist-table-meta__page {
  color: #8b95a8;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  margin: 0;
}

.hist-pagination-wrap {
  padding: 0.15rem 0 0.15rem;
}

.hist-pagination {
  justify-content: center;
  width: 100%;
}

.hist-pagination__nav {
  align-items: center;
  display: inline-flex;
  gap: 0.35rem;
  font-size: 0.72rem;
  font-weight: 600;
}

.hist-pagination__nav-text {
  display: none;
}

@media (min-width: 400px) {
  .hist-pagination__nav-text {
    display: inline;
  }
}

.hist-modal-content {
  background: #1d1f26 !important;
  border: none !important;
  border-radius: 14px !important;
  overflow: hidden;
}

.hist-modal-close {
  align-items: center;
  background: rgba(220, 53, 69, 0.85);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 1.1rem;
  font-weight: 700;
  height: 28px;
  justify-content: center;
  line-height: 1;
  margin: 0.5rem 0.5rem 0 auto;
  width: 28px;
}

/* Data table on dark card */
.hist-card--table >>> .table-custom {
  color: #e8eaef !important;
  margin-bottom: 0;
}

.hist-card--table >>> .thead-light th {
  background: #252830 !important;
  border-color: rgba(255, 255, 255, 0.06) !important;
  color: #8b95a8 !important;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
}

.hist-card--table >>> .list {
  background: #1d1f26 !important;
}

.hist-card--table >>> .list tr:nth-child(even) th {
  background: rgba(255, 255, 255, 0.02) !important;
}

.hist-card--table >>> .list th {
  border-color: rgba(255, 255, 255, 0.06) !important;
  padding-top: 0.55rem !important;
  padding-bottom: 0.55rem !important;
  vertical-align: middle;
}

.hist-card--table >>> .name,
.hist-card--table >>> .text-md {
  color: #f0f2f5 !important;
}

.hist-card--table >>> .badge {
  font-size: 0.65rem;
  font-weight: 600;
}

/* vue-select */
.hist-select-wrap >>> .vs__dropdown-toggle {
  background: #252830 !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 0.15rem 0.35rem;
}

.hist-select-wrap >>> .vs__selected,
.hist-select-wrap >>> .vs__search {
  color: #f0f2f5 !important;
}

/* Vant pagination — clearer controls on dark card */
.hist-pagination-wrap >>> .van-pagination {
  flex-wrap: wrap;
  gap: 0.35rem 0.15rem;
  justify-content: center;
  padding: 0.25rem 0;
}

.hist-pagination-wrap >>> .van-pagination__items {
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 -0.15rem;
}

.hist-pagination-wrap >>> .van-pagination__item {
  background: #2a2e38;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  box-sizing: border-box;
  color: #c5cad6;
  font-size: 0.75rem;
  font-weight: 600;
  margin: 0.15rem !important;
  min-height: 2.25rem;
  min-width: 2.25rem;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
}

.hist-pagination-wrap >>> .van-pagination__item:active {
  background: #353a46 !important;
}

.hist-pagination-wrap >>> .van-pagination__item--active {
  background: linear-gradient(180deg, #6a9fff 0%, #5c98ff 100%) !important;
  border-color: rgba(92, 152, 255, 0.65) !important;
  box-shadow: 0 2px 10px rgba(92, 152, 255, 0.28);
  color: #fff !important;
}

.hist-pagination-wrap >>> .van-pagination__item--active::after,
.hist-pagination-wrap >>> .van-pagination__page::after {
  border-radius: 10px;
}

.hist-pagination-wrap >>> .van-pagination__prev,
.hist-pagination-wrap >>> .van-pagination__next {
  background: #252830;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #dce1ea;
  flex-shrink: 0;
  margin: 0.15rem !important;
  min-height: 2.25rem;
  padding: 0 0.65rem !important;
}

.hist-pagination-wrap >>> .van-pagination__prev.van-pagination__item--disabled,
.hist-pagination-wrap >>> .van-pagination__next.van-pagination__item--disabled {
  opacity: 0.38;
  pointer-events: none;
}

@media (max-width: 576px) {
  .hist-seg {
    font-size: 0.65rem;
    min-width: 0;
    padding: 0.45rem 0.4rem;
  }
}
</style>
